import { FC, useState, useRef, useEffect } from 'react';
import styles from './SortFilter.module.scss';
import { useClickOutside } from 'hooks/useOnClickOutside';
import { ReactComponent as IconCloseBlue } from '../img/filters/iconCloseBlue.svg';
import { ReactComponent as IconSort } from '../img/filters/iconSort.svg';
import { KeysFiltersType } from 'redux/Api/employedsApi/type';

interface PropsType {
  active?: string;
  lists: KeysFiltersType[];
  setActive: (tab: string) => void;
  localStorageKey?: string;
  isLoading?: boolean;
}

export const SortFilter: FC<PropsType> = ({
  active,
  lists,
  setActive,
  localStorageKey = 'employedsSort',
  isLoading = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const clickOutsideRef = useClickOutside(() => setIsOpen(false));
  const rootRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const name = lists?.find((item) => item.keyword === active)?.title;

  useEffect(() => {
    if (!contentRef.current || !rootRef.current || !name) return;

    const updateFlexBasis = () => {
      const styles = window.getComputedStyle(contentRef.current!);
      const measureEl = document.createElement('span');
      measureEl.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;';
      measureEl.style.font = styles.font;
      measureEl.textContent = name;

      document.body.appendChild(measureEl);
      const textWidth = measureEl.offsetWidth;
      document.body.removeChild(measureEl);

      const padding =
        parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight) || 32;
      const gap = parseFloat(styles.gap) || 6;
      const iconWidth =
        contentRef.current!.querySelector('svg')?.getBoundingClientRect().width || 20;

      rootRef.current!.style.flexBasis = `${textWidth + padding + gap + iconWidth}px`;
    };

    const rafId = requestAnimationFrame(updateFlexBasis);
    window.addEventListener('resize', updateFlexBasis);

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('resize', updateFlexBasis);
    };
  }, [active, lists, name]);

  const handleClearSort = () => {
    if (isLoading) return;
    localStorage.setItem(localStorageKey, 'default');
    setActive('default');
    setIsOpen(false);
  };

  const Menu = () => {
    return (
      <ul className={styles.list} ref={clickOutsideRef}>
        {lists?.map((item, i) => (
          <li
            className={`${styles.item} ${
              item.keyword === active ? styles.item_active : ''
            }`}
            onClick={() => {
              localStorage.setItem(localStorageKey, item.keyword);
              setActive(item.keyword);
              setIsOpen(false);
            }}
            key={i}>
            {item.title}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div ref={rootRef} className={styles.root}>
      <div
        ref={contentRef}
        className={`${styles.content} ${active !== 'default' ? styles.active : ''}`}
        onClick={() => setIsOpen((prev) => !prev)}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          {active === 'default' && <IconSort />}
          <span
            style={{
              color: active === 'default' ? '#71869D' : '#002CFB',
            }}>
            Сортировка
          </span>
          {active !== 'default' && (
            <IconCloseBlue
              onClick={(e: any) => {
                e.stopPropagation();
                e.preventDefault();
                handleClearSort();
              }}
            />
          )}
        </div>
      </div>
      {isOpen && <Menu />}
    </div>
  );
};
